export default class exampleClient {
    constructor() {
        this.message = 'none';
    }

    setMessage(message) {
        this.message = message;
    }

    getMessage() {
        return this.message;
    }
}


// WEBPACK FOOTER //
// /src/common/partials/example-partial/client.js